import { render, staticRenderFns } from "./ReceptionDetailCommentEditor.vue?vue&type=template&id=31f5210f&scoped=true&"
import script from "./ReceptionDetailCommentEditor.vue?vue&type=script&lang=ts&"
export * from "./ReceptionDetailCommentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionDetailCommentEditor.vue?vue&type=style&index=0&id=31f5210f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f5210f",
  null
  
)

export default component.exports